import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "primeng/button";;
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { DividerModule } from "primeng/divider";
import { ItemServicoInserirComponent } from "./item-servico-inserir.component";
import { ItemServicoInserirRoutingModule } from "./item-servico-inserir-routing.module";
import { ConfirmationService } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { MessagesModule } from "primeng/messages";
import { DropdownModule } from "primeng/dropdown";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputNumberModule } from "primeng/inputnumber";
import { InputMaskModule } from "primeng/inputmask";
import { DialogModule } from "primeng/dialog";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { CalendarModule } from "primeng/calendar";
import { TooltipModule } from "primeng/tooltip";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ItemServicoInserirRoutingModule,
        ButtonModule,
        InputTextModule,
        TableModule,
        HttpClientModule,   
        DividerModule,
        MessagesModule,
        DropdownModule,
        InputSwitchModule,
        InputNumberModule,
        InputMaskModule,
        ProgressSpinnerModule,
        CalendarModule,
        DialogModule,
        TooltipModule
    ],
    providers: [ConfirmationService],
    declarations: [ItemServicoInserirComponent]
})
export class ItemServicoInserirModule { }
